<script setup lang="ts">
  withDefaults(defineProps<{ inverse?: boolean }>(), { inverse: false })
</script>

<template>
  <span class="eyebrow" :class="{ 'eyebrow--inverse': inverse }">
    <slot />
  </span>
</template>

<style scoped lang="scss">
  .eyebrow {
    display: block;
    font-family: var(--bf-font-display);
    font-size: var(--bf-fs-xs);
    font-weight: var(--bf-fw-bold);
    text-transform: uppercase;
    letter-spacing: var(--bf-tr-eyebrow);
    color: var(--bf-orange-dark);

    &--inverse {
      color: var(--bf-orange-light);
    }
  }
</style>
